module.exports = __webpack_public_path__ + "static/media/udeSayu.b1087c51.png";